"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PlatformModal;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const ThemeContext_1 = require("../ThemeContext");
const react_native_paper_1 = require("react-native-paper");
const ResponsiveContext_1 = require("../contexts/ResponsiveContext");
const useStyles = () => {
    const THEME = (0, ThemeContext_1.useTheme)();
    const { size } = (0, ResponsiveContext_1.useResponsiveContext)();
    return react_native_1.StyleSheet.create({
        backdrop: {
            backgroundColor: "rgba(0,0,0,0.4)",
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center'
        },
        dialog: {
            backgroundColor: THEME.CardBackground,
            borderRadius: size != 'sm' ? 4 : 4,
            padding: size != 'sm' ? 24 : 12,
            minWidth: size != 'sm' ? 480 : "95%",
            maxWidth: size != 'sm' ? "60%" : "95%",
            maxHeight: "84%"
        },
        bottomSheetBackdrop: {
            justifyContent: "flex-end"
        },
        bottomSheetDialog: {
            alignSelf: "center",
            width: size != "sm" ? "92%" : "100%",
            minWidth: 0,
            maxWidth: 1280,
            minHeight: size != "sm" ? 320 : undefined,
            maxHeight: "75%",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            paddingHorizontal: size != "sm" ? 48 : 16,
            paddingTop: size != "sm" ? 32 : 16,
            paddingBottom: size != "sm" ? 40 : 24
        }
    });
};
function PlatformModal(props) {
    const styles = useStyles();
    const content = props.scroll === false ? ((0, jsx_runtime_1.jsx)(react_native_1.View, { children: props.children })) : ((0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { showsVerticalScrollIndicator: false, showsHorizontalScrollIndicator: false, children: props.children }));
    return (props.usePaper
        &&
            (0, jsx_runtime_1.jsx)(react_native_paper_1.Modal, { contentContainerStyle: [styles.dialog, { alignSelf: 'center', maxWidth: 550 }], visible: props.isVisible, onDismiss: () => props.onDismiss(), children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { style: [{ pointerEvents: "auto" }], children: content }) })
        ||
            (0, jsx_runtime_1.jsx)(react_native_1.Modal, { animationType: 'fade', transparent: true, visible: props.isVisible, style: { maxWidth: 550 }, onRequestClose: () => props.onDismiss(), children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { style: [{ pointerEvents: "box-only" }, styles.backdrop, props.bottomSheet ? styles.bottomSheetBackdrop : null], onPress: () => props.onDismiss(), children: (0, jsx_runtime_1.jsx)(react_native_1.Pressable, { style: [{ pointerEvents: "auto" }, styles.dialog, props.bottomSheet ? styles.bottomSheetDialog : null, props.webMinWidth ? { minWidth: props.webMinWidth } : null], children: (0, jsx_runtime_1.jsx)(react_native_1.ScrollView, { children: props.children }) }) }) }));
}
